import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "app-system-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemHeader = _resolveComponent("SystemHeader")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_SystemMenu = _resolveComponent("SystemMenu")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_PcTabsBar = _resolveComponent("PcTabsBar")!
  const _component_PcMain = _resolveComponent("PcMain")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_backtop = _resolveComponent("el-backtop")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"100vh"} }, {
    default: _withCtx(() => [
      (!_ctx.inScreenfull)
        ? (_openBlock(), _createBlock(_component_el_header, {
            key: 0,
            style: {"height":"64px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SystemHeader)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          (!_ctx.inScreenfull)
            ? (_openBlock(), _createBlock(_component_SystemMenu, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_main, {
            style: _normalizeStyle(`min-width:1072px;${_ctx.inScreenfull?'height:100%;background-color:#fff':'height:calc(100vh - 64px);'}`)
          }, {
            default: _withCtx(() => [
              (!_ctx.inScreenfull)
                ? (_openBlock(), _createBlock(_component_Breadcrumb, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_1, [
                (_ctx.show)
                  ? (_openBlock(), _createBlock(_component_PcTabsBar, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_PcMain)
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_el_backtop, {
            target: ".el-main",
            right: 16,
            bottom: 16
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}